module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_fds.ff874a8fc594fcf123c3730120ef425e.png";